import "./MainNavigation.css";
import TaskDisplaySwitch from "./TaskDisplaySwitch";
import TaskSearch from "./TaskSearch";

const VIEWS = [
  ["tasks", "📋 Tâches"],
  ["lists", "📝 Listes permanentes"],
  ["hours", "⏱️ Heures travaillées"],
  ["sport", "🏃 Sport"],
  ["ledger", "💰 Comptes"],
];

export default function MainNavigation({
  activeView,
  onViewChange,
  authUser,
  onLogout,
  taskDisplayMode = "order",
  onTaskDisplayModeChange,
  tasks = [],
  onGoToTask,
}) {
  return (
    <header className="app-topbar">
      <div className="topbar-panels">


          <nav className="main-nav-tabs" aria-label="Modules de l’application">
            {VIEWS.map(([view, label]) => (
              <button
                key={view}
                type="button"
                className={`main-nav-tab ${
                  activeView === view ? "active" : ""
                }`}
                onClick={() => onViewChange(view)}
                aria-current={activeView === view ? "page" : undefined}
              >
                {label}
              </button>
            ))}

            <div className="main-nav-search">
              <TaskSearch
                tasks={tasks}
                onGoToTask={onGoToTask}
              />
            </div>
          </nav>

      </div>

       <section className="display-panel" aria-label="Réglages d’affichage">
          <TaskDisplaySwitch
            value={taskDisplayMode}
            onChange={onTaskDisplayModeChange}
          />
        </section>

      <div className="app-user-menu">
        <span className="app-user-label">
          Connecté : {authUser?.prenom || authUser?.login || "Utilisateur"}
        </span>

        <button
          type="button"
          className="logout-button"
          onClick={onLogout}
        >
          Déconnexion
        </button>
      </div>
    </header>
  );
}
